/**
 * アプリ1つぶんのサービス一式(シングルトン)。
 *
 * ローカルモード / Firebase モードの選択は `factory.ts` が env から決める
 * (`VITE_FIREBASE_*` が揃っていれば callable 経由、無ければ localStorage)。
 *
 * `gameStore` と `authStore` は**同じ**インスタンスを共有する必要がある
 * (`createServices()` を2回呼ぶと Firebase アプリが2つできて匿名ユーザーが割れる)。
 */
import { createServices } from './factory';

export const appServices = createServices();
